import React, { useState} from 'react'
import { Grid, Button} from '@mui/material';
import Modal, { ModalBody, ModalFooter, ModalHeader } from '../../components/Modal/modal'
import EditList from '../../components/EditList/EditList';
import axios from "axios";
import { URL } from '../../constants/constant';

const EditUnit = ({selectedRows, setOpen, setMessage, getTableData}) => {
    const [showModal, setShowModal] = useState(false);
    const [unitsList, setUnitsList] = useState([])

    const modalButtonClick = () => {
        if (selectedRows.length <= 0) {
            setOpen(true)
            setMessage('Please select a Package first')
            return
        }
        setUnitsList(selectedRows[0].units.split(', '))
        setShowModal(true)
    }

    const closeModal = () => {
        setUnitsList(selectedRows[0].units.split(', '))
        setShowModal(false)
    }

    const removeUnit = (keyName) => {
        if (unitsList.length === 1) {
            setOpen(true)
            setMessage('You can not remove all the units')
            return
        }
        setUnitsList(unitsList.filter((key) => key !== keyName));
    }

    const EditUnitAPI = () => {
        if (unitsList.join(', ') === selectedRows[0].units) {
            setOpen(true)
            setMessage('Please make changes before saving')
            return
        }
        const unitsListConcat = unitsList.join(',')
        const user = JSON.parse(localStorage.getItem("loggedInUserDetails")).emailId;

        const data = JSON.stringify({
            "subtest_name" : selectedRows[0].subtest_name,
            "newUnits": unitsListConcat,
            "user": user
        });
        
        var config = {
            method: 'post',
            url: URL.demystify_url + 'knowledgeBase/editUnits',
            headers: { 
            'Content-Type': 'application/json'
            },
            data : data
        };

        axios(config)
        .then(function (response) {
            if(response.data.success === 1){
                setOpen(true); 
                setMessage("Units edited succesfully"); 
                getTableData();
            }
            else if(response.data.success === 0){
                setOpen(false); 
                setMessage(response.data.errorMessage);
            }
        })
        .catch(function (error) {
            alert("Something went wrong, please try again")
            console.log(error);
        });

        closeModal()
    }

    return (
        <Grid>
            <div className='add-keyword'>
                    <Button variant='contained' onClick={modalButtonClick}>
                        Edit Unit
                    </Button>
                </div>

                <div>
                    <Modal show={showModal} setShow={setShowModal}>
                        <ModalHeader className='modal-header'>
                            <h2>Edit Unit</h2>
                        </ModalHeader>
                        <ModalBody>
                            <div className='subtest-name' >
                                <div className='new-key-word' style={{justifyContent:'center'}}>
                                    <h3 style={{textAlign:'center',fontWeight:'bold'}}>Sub Test Name : {selectedRows.length>0 ? selectedRows[0].subtest_name:undefined}</h3>
                                </div>
                            </div>
                            <EditList 
                                stateList={unitsList} 
                                removeItem={removeUnit}
                                setOpen={setOpen}
                                setMessage={setMessage}
                            />
                        </ModalBody>

                        <ModalFooter>
                            <Button variant="contained" style={{marginRight: 50}} onClick={EditUnitAPI}>Save</Button>
                            <Button onClick={closeModal} variant="outlined">
                                Close
                            </Button>
                        </ModalFooter>
                    </Modal>
                </div>
        </Grid>
    )
}

export default EditUnit